// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { generateId, timeAgo } from '../../_common/api/utility';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import Card from '../Card';
import { requestForToken } from '../../../firebase';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { HamQuest } from '../../../App';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    padding: 0.5em;
    ${({ top, theme }) => top && `border-top: 1px solid ${theme.mobile.secondary};`}
`
const DateLine = styled.div`
    display: flex;
    justify-content: flex-end;
    opacity: 0.7;
    font-size: 0.7em;
`

const Notifications = ({ ...props }) => {
    const { state: {
        active_user,
    },
        getNotifications
    } = useGlobalState();

    const [notif, setNotif] = useState(active_user.notifications?.messages);

    useEffect(() => {
        getNotifications()
            .then(res => setNotif(res))
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get Notifications',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    return (
        <Card>
            <Title icon='bell'>Notifications</Title>
            {
                notif?.map((e, i) =>
                    <Wrapper key={generateId()} top={i !== 0} read={e.read}>
                        <div><b>{!e.read ? <b style={{ color: 'red', fontSize: '1.5em' }}>·</b> : null} {e.title}</b></div>
                        <div>{e.body}</div>
                        <DateLine>{timeAgo(e.createDate)}</DateLine>
                    </Wrapper>
                )
            }
        </Card>
    );
}

export default Notifications;

export const getNotifPermissions = () => {
    if (window.deviceToken) {
        console.log('Firebase Device ID:', window.deviceToken);

        HamQuest.post(QuestRoute.user.firebaseToken, {
            token: window.deviceToken
        })
            .then(() => console.log('Token added successfully.'))
            .catch(() => console.error('Failed to add Token.'))
    } else {
        requestForToken();
    }
}